import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function addRenewalDays(renewalDate: string, days: number): string {
  return dayjs.utc(renewalDate).add(days, "day").toISOString();
}
